<div data-testid="permission-tree-tabs" class="mb-6 border-b border-gray-200">
  <nav class="-mb-px flex items-center space-x-8">
    @for (tab of permissionTabs; track tab.app) {
      <button
        [attr.data-testid]="
          'permission-tree-tab-' + tab.app.replaceAll('.', '-')
        "
        type="button"
        class="border-b-2 px-1 py-2 text-sm font-medium transition-colors"
        [class.border-blue-500]="isActiveTab(tab.app)"
        [class.text-blue-600]="isActiveTab(tab.app)"
        [class.border-transparent]="!isActiveTab(tab.app)"
        [class.text-gray-500]="!isActiveTab(tab.app)"
        [class.hover\:border-gray-300]="!isActiveTab(tab.app)"
        [class.hover\:text-gray-700]="!isActiveTab(tab.app)"
        (click)="selectTab(tab.app)"
      >
        {{ tab.label }}
      </button>
    }
  </nav>
</div>

<div data-testid="permission-tree-container" class="space-y-4">
  @for (menu of visibleMenus(); track menu.name) {
    <div class="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div
        [attr.data-testid]="
          'permission-tree-menu-' + menu.name.replaceAll('.', '-')
        "
        class="flex items-center gap-3 bg-gray-100 px-4 py-3 text-base font-semibold cursor-pointer"
        (click)="toggleMenuExpand(menu)"
      >
        <p-checkbox
          [attr.data-testid]="
            'permission-tree-menu-checkbox-' + menu.name.replaceAll('.', '-')
          "
          class="transition-opacity"
          [class.opacity-50]="readOnly()"
          [binary]="true"
          [disabled]="readOnly()"
          [ngModel]="isMenuChecked(menu)"
          (click)="$event.stopPropagation()"
          (onChange)="toggleMenu(menu)"
        >
        </p-checkbox>

        <span class="flex-1">
          {{ getMenuLabel(menu.name) }}
        </span>

        <span
          class="material-symbols-outlined text-gray-500 transition-transform duration-200"
          [class.rotate-180]="menu.expanded"
        >
          expand_more
        </span>
      </div>

      @if (menu.expanded || searchTerm().trim()) {
        <div>
          @for (sub of menu.submenus; track sub.name) {
            <div class="bg-gray-50 px-4 py-3">
              <div
                [attr.data-testid]="
                  'permission-tree-submenu-' +
                  menu.name.replaceAll('.', '-') +
                  '-' +
                  sub.name.replaceAll('.', '-')
                "
                class="flex items-center gap-3 font-medium cursor-pointer pl-6"
                (click)="toggleSubmenuExpand(sub)"
              >
                <p-checkbox
                  [attr.data-testid]="
                    'permission-tree-submenu-checkbox-' +
                    menu.name.replaceAll('.', '-') +
                    '-' +
                    sub.name.replaceAll('.', '-')
                  "
                  class="transition-opacity"
                  [class.opacity-50]="readOnly()"
                  [binary]="true"
                  [disabled]="readOnly()"
                  [ngModel]="isSubmenuChecked(sub)"
                  (click)="$event.stopPropagation()"
                  (onChange)="toggleSubmenu(menu, sub)"
                >
                </p-checkbox>

                <span class="flex-1 text-gray-700">
                  {{ getSubmenuLabel(sub.name, menu.name) }}
                </span>

                <span
                  class="material-symbols-outlined text-gray-500 transition-transform duration-200"
                  [class.rotate-180]="sub.expanded"
                >
                  expand_more
                </span>
              </div>

              @if (sub.expanded || searchTerm().trim()) {
                <div class="mt-3 flex flex-wrap gap-4 pl-12">
                  @for (action of sub.actions; track action.code) {
                    <div class="flex items-center gap-2 rounded-md px-3 py-1.5">
                      <p-checkbox
                        [attr.data-testid]="
                          'permission-tree-action-checkbox-' +
                          action.code.replaceAll('.', '-')
                        "
                        class="transition-opacity"
                        [class.opacity-50]="readOnly()"
                        [binary]="true"
                        [disabled]="readOnly()"
                        [(ngModel)]="action.checked"
                        (onChange)="toggleAction()"
                      >
                      </p-checkbox>

                      <span class="text-sm text-gray-600">
                        {{ getActionLabel(action.action) }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
